import React, { useContext } from "react";
import HeaderBack from "../../components/HeaderBack";
import { OrderContext } from "../../contexts/OrderContext";
import { useParentGoBackMessage } from "../../hooks";
import OrderTipEmployee from "./components/OrderTipEmployee";
import OrderTipTips from "./components/OrderTipTips";

const EOrderTipPage = () => {
	// TODO adjust to leave tip after order payment
	const { order } = useContext(OrderContext);
	useParentGoBackMessage(false);

	return (
		<>
			<HeaderBack />
			<main>
				<OrderTipEmployee employee={order?.employee} />
				{order?.to_pay && <OrderTipTips totalPrice={order.to_pay} />}
			</main>
		</>
	);
};

export default EOrderTipPage;
